import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';

import { Auth } from 'aws-amplify';
// 🛑 CRÍTICO: Importamos Authenticator y sus estilos
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css'; 

// Importación de componentes existentes
import NavbarResponsive from './components/NavbarResponsive';
import Home from './components/Home';
import CatalogPage from './components/CatalogPage';
import DetailPage from './components/DetailPage';
import AdminDashboard from './components/AdminDashboard';
// Ya NO es necesario importar AdminLogin

import EditVehicleForm from './components/EditVehicleForm';

// 🚀 NUEVA IMPORTACIÓN: Página de detalles especial para Caracas
import CarDetailsCaracas from './components/CarDetailsCaracas'; 

// Componente de página de error simple
const NotFound = () => <div style={{ textAlign: 'center', padding: '50px' }}>
    <h2>404 - Página no encontrada</h2>
    <p>La URL a la que intentas acceder no existe.</p>
</div>;

// Componente de ACCESO DENEGADO
const AccessDenied = () => (
    <div style={{ textAlign: 'center', padding: '50px', color: 'red', fontWeight: 'bold' }}>
        <h2>❌ ACCESO DENEGADO ❌</h2>
        <p>No tienes los permisos necesarios para acceder a esta área.</p>
        <p>Inicia sesión con una cuenta de administrador.</p>
    </div>
);


// -------------------------------------------------------------------------
// Lógica para Proteger Rutas: Maneja la autenticación y el rol
// -------------------------------------------------------------------------
function RequireAuth({ children, authStatus, isAdmin, user }) {
    const navigate = useNavigate();

    // 1. Si NO está autenticado, muestra el formulario de Login/Auth de Amplify
    if (authStatus !== 'authenticated') {
        return (
            <div style={{ padding: '20px', maxWidth: '400px', margin: '80px auto' }}>
                <Authenticator>
                    {() => {
                        // Si el login fue exitoso dentro del Authenticator, navegamos para forzar la verificación de rol
                        if (authStatus === 'authenticated') {
                            navigate('/admin', { replace: true });
                            return null;
                        }
                        return null;
                    }}
                </Authenticator>
            </div>
        );
    }
    
    // 2. Si está autenticado pero NO es administrador
    if (!isAdmin) {
        return <AccessDenied />;
    }
    
    // 3. Si está autenticado Y es administrador, permite el acceso
    return children;
}

// -------------------------------------------------------------------------
// Componente que maneja las Rutas Anidadas del Admin (sin cambios)
// -------------------------------------------------------------------------
const AdminRoutes = ({ user, isAdmin, onSignOut }) => {
    const navigate = useNavigate();
    
    const handleVehicleUpdated = () => {
        navigate('/admin');
    };

    return (
        <Routes>
            <Route path="/" element={
                <AdminDashboard 
                    user={user} 
                    isAdmin={isAdmin} 
                    onSignOut={onSignOut} 
                />
            } />
            
            <Route 
                path="vehiculo/editar/:id" 
                element={<EditVehicleForm onVehicleUpdated={handleVehicleUpdated} />} 
            />
            
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};


// -------------------------------------------------------------------------
// COMPONENTE PRINCIPAL APP
// -------------------------------------------------------------------------
export default function App() {
    const { user, signOut, authStatus } = useAuthenticator(context => [
        context.user, 
        context.signOut, 
        context.authStatus
    ]);
    
    const [isAdmin, setIsAdmin] = useState(false);
    
    useEffect(() => {
        // Esta función se ejecuta CADA VEZ que el objeto 'user' cambia.
        const checkAdminStatus = () => {
            if (user && user.signInUserSession && user.signInUserSession.idToken) {
                const idTokenPayload = user.signInUserSession.idToken.payload;
                const groups = idTokenPayload["cognito:groups"] || [];
                
                // 🛑 CORRECCIÓN DE CASO: Buscamos el nombre exacto del grupo: "ADMIN"
                if (groups.includes("ADMIN")) { 
                    console.log("🟢 Autorización Exitosa: Rol ADMIN detectado.");
                    setIsAdmin(true);
                    return;
                }
            }
            console.log("🔴 Autorización Fallida: No es administrador o token no disponible.");
            setIsAdmin(false);
        };

        checkAdminStatus();
    }, [user]); // Reacciona de forma CRÍTICA a cualquier cambio en el objeto 'user'.

    if (authStatus === 'configuring') {
        return <div style={{ textAlign: 'center', padding: '50px' }}>Cargando Aplicación...</div>;
    }

    const handleSignOut = () => {
        signOut();
    };

    return (
        <Router>
            <NavbarResponsive 
                user={user} 
                isAdmin={isAdmin} 
                onSignOut={handleSignOut} 
            />
            <main>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/catalogo" element={<CatalogPage />} />
                    
                    {/* 🚀 RUTA ESPECIAL: Se coloca antes de la genérica para que tenga prioridad */}
                    <Route path="/vehiculo/frontlander-2025-ccs" element={<CarDetailsCaracas />} />

                    <Route path="/vehiculo/:id" element={<DetailPage />} /> 
                    
                    {/* RUTA DE ADMINISTRACIÓN PROTEGIDA */}
                    <Route path="/admin/*" element={
                        <RequireAuth 
                            user={user} 
                            authStatus={authStatus}
                            isAdmin={isAdmin} 
                        >
                            <AdminRoutes user={user} isAdmin={isAdmin} onSignOut={handleSignOut} />
                        </RequireAuth>
                    } />
                    
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>
        </Router>
    );
}